const AgreementListType = {
    CREATED: "CREATED",
    AVAILABLE: "AVAILABLE"
}
export default AgreementListType;